import { useDispatch, useSelector } from "react-redux";
import BotonSubmit from "../../../../../components/Boton/BotonSubmit";
import { startPostInfoPago } from "../../../../../context/actions/proveedoresActions";
import { emailsEditarInfoPago } from "../../../../../constants/cons";

export default function Enviar() {
  const dispatch = useDispatch();
  const { email } = useSelector((state) => state.userReducer.user);
  const puedeEditar = emailsEditarInfoPago.includes(email);
  const handleClick = () => {
    if (puedeEditar) dispatch(startPostInfoPago());
  };
  return (
    <div className="contenedorBotonSubmit" style={{ maxWidth: 250 }}>
      <BotonSubmit onClick={handleClick} tituloBoton="Actualizar información" disabled={!puedeEditar} />
    </div>
  );
}
